import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import useDocumentTitle from '../hooks/useDocumentTitle';

const NotFoundPage = () => {
  const { language, t } = useLanguage();
  useDocumentTitle(language === 'fr' ? 'Page introuvable' : 'Page Not Found');

  const c = language === 'fr'
    ? { title: 'Page introuvable', sub: "La page que vous recherchez n'existe pas ou a été déplacée.", back: "Retour à l'accueil", explore: "Explorer l'écosystème" }
    : { title: 'Page Not Found', sub: "The page you are looking for doesn't exist or has been moved.", back: 'Back to Home', explore: 'Explore the Ecosystem' };

  return (
    <div className="min-h-screen pt-32 pb-20 flex items-center bg-[#1a1c1b] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full blur-3xl" style={{ background: 'radial-gradient(circle, #5B7A8A 0%, transparent 70%)' }} />
        <div className="absolute -bottom-40 -right-40 w-[600px] h-[600px] rounded-full blur-3xl" style={{ background: 'radial-gradient(circle, #E07B54 0%, transparent 70%)' }} />
      </div>

      <div className="container-swg relative z-10">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="max-w-2xl mx-auto text-center">
          <motion.h1 initial={{ scale: 0.8 }} animate={{ scale: 1 }} transition={{ duration: 0.6, delay: 0.1 }} className="text-[120px] md:text-[180px] font-black text-[#5B7A8A] leading-none mb-4">
            404
          </motion.h1>
          <div className="accent-line mx-auto mb-8"></div>
          <h2 className="heading-2 text-white mb-4">{c.title}</h2>
          <p className="body-large text-[#9AACB8] mb-12">{c.sub}</p>

          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/home" className="btn-primary" data-testid="notfound-home-btn">
              <Home className="w-4 h-4 mr-2" />
              {c.back}
            </Link>
            <Link to="/ecosystem" className="btn-secondary" data-testid="notfound-ecosystem-btn">
              <ArrowLeft className="w-4 h-4 mr-2" />
              {c.explore}
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFoundPage;
